<template>
  <div class="returntop" v-if="btnFlag" @click="backTop">      
    <i class="iconfont icon-zhiding1"></i>
  </div>
</template>

<script>
export default {
    name: 'returntop',
    props: {
        msg: String
    },
    data () {
        return {
            btnFlag:false,
            scrollTop: 0,
        }
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
 
methods: {
  // 点击图片回到顶部方法，加计时器是为了过渡顺滑
  backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
  },
  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
            that.btnFlag = true
            } else {
            that.btnFlag = false
            }
        }
    }
}
</script>

<style>
.returntop{
  position: fixed;
  bottom: 120px;
  right: 20px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  border-radius: 50%;
  z-index: 99;
}
.icon-zhiding1{
  font-size: 40px !important;       
}
.icon-zhiding1:hover{
  color: #932120 !important;       
}
</style>